import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { formatApiError } from '../lib/api';
import api from '../lib/api';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, Lock, CheckCircle, XCircle, Eye, EyeOff } from 'lucide-react';

const LOGO = '/logo.png';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [showPwd, setShowPwd] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError('');
    if (password.length < 6) { setError('Mínimo 6 caracteres'); return; }
    if (password !== confirm) { setError('Las contraseñas no coinciden'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      setDone(true);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center px-4 bg-[#F4F5F7]">
        <div className="w-full max-w-sm bg-white border-2 border-[#0B1F40] p-8 brutal-shadow text-center">
          <XCircle className="h-12 w-12 text-[#E50B15] mx-auto mb-4" />
          <p className="text-sm text-[#E50B15] font-bold mb-4">Enlace inválido</p>
          <Link to="/forgot-password">
            <button className="w-full bg-[#0B1F40] text-white font-black text-sm h-10">SOLICITAR NUEVO ENLACE</button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="reset-password-page" className="min-h-[80vh] flex items-center justify-center px-4 bg-[#F4F5F7]">
      <div className="w-full max-w-sm animate-fade-in">
        <div className="bg-white border-2 border-[#0B1F40] p-8 brutal-shadow">
          <div className="flex flex-col items-center mb-6">
            <img src={LOGO} alt="RP" className="h-14 w-14 mb-4 border-2 border-[#0B1F40]" />
            <h1 className="text-xl text-[#0B1F40] tracking-tighter" style={{ fontFamily: 'Archivo Black' }}>NUEVA CONTRASEÑA</h1>
          </div>

          {done ? (
            <div className="text-center">
              <CheckCircle className="h-12 w-12 text-emerald-600 mx-auto mb-4" />
              <p className="text-sm text-[#0B1F40]/70 font-bold mb-2">Contraseña actualizada</p>
              <p className="text-xs text-[#0B1F40]/50 mb-6">Ya puedes iniciar sesión con tu nueva contraseña.</p>
              <Link to="/login">
                <button className="w-full bg-[#E50B15] text-white font-black text-sm h-10 brutal-btn-press transition-all" style={{ boxShadow: '4px 4px 0px #0B1F40' }}>IR A INICIAR SESIÓN</button>
              </Link>
            </div>
          ) : (
            <>
              {error && <div data-testid="reset-error" className="mb-4 p-3 bg-red-50 border-l-4 border-[#E50B15] text-[#E50B15] text-xs font-bold">{error}</div>}
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label className="text-[10px] font-black tracking-[0.15em] uppercase text-[#0B1F40]/50">NUEVA CONTRASEÑA</Label>
                  <div className="relative mt-1">
                    <Input data-testid="reset-password" type={showPwd ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)}
                      className="rounded-none border-2 border-[#0B1F40]/20 focus:border-[#E50B15] focus:ring-0 h-11 font-bold pr-11" placeholder="Mínimo 6 caracteres" required />
                    <button type="button" data-testid="toggle-password-reset" onClick={() => setShowPwd(!showPwd)}
                      className="absolute right-0 top-0 h-11 w-11 flex items-center justify-center text-[#0B1F40]/40 hover:text-[#E50B15] transition-colors">
                      {showPwd ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                    </button>
                  </div>
                </div>
                <div>
                  <Label className="text-[10px] font-black tracking-[0.15em] uppercase text-[#0B1F40]/50">CONFIRMAR CONTRASEÑA</Label>
                  <div className="relative mt-1">
                    <Input data-testid="reset-confirm" type={showPwd ? 'text' : 'password'} value={confirm} onChange={e => setConfirm(e.target.value)}
                      className="rounded-none border-2 border-[#0B1F40]/20 focus:border-[#E50B15] focus:ring-0 h-11 font-bold pr-11" placeholder="Repite la contraseña" required />
                  </div>
                </div>
                <button data-testid="reset-submit" type="submit" disabled={loading}
                  className="w-full bg-[#E50B15] text-white font-black text-sm h-11 flex items-center justify-center gap-2 brutal-btn-press transition-all" style={{ boxShadow: '4px 4px 0px #0B1F40' }}>
                  {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} CAMBIAR CONTRASEÑA
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
